import { Inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from 'config-token';
import { AbstractNewRelicService, NewRelicBaseActionData, NewRelicCustomAction, NewRelicAction } from 'osn-shared';
import { Config } from '../../config';

@Injectable()
export class NewRelicService extends AbstractNewRelicService {
  constructor(@Inject(CONFIG_TOKEN) private readonly config: Config) {
    super();
  }

  public createBasicAction(callingContext: string, stackTrace: string): NewRelicBaseActionData {
    return {
      action: undefined,
      ip: 'unknown',
      environment: this.config.newRelicEnvironment,
      userId: '',
      callingContext,
      stackTrace,
    };
  }

  public sendAction<A extends NewRelicCustomAction, T extends NewRelicAction & { action: A }>(action: A, data: Omit<T, 'action'>) {}

  public noticeError(error: string | Error) {}
}
